// 运行环境相关
// 2022-04-14

import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
import { getQueryString, isTHSApp, isTHSI18NApp, isDeviceMobile, getRunEnv as _getRunEnv } from '@/utils/tools'

//1自研 同花顺公版、网厅2， 站外3 同花顺国际版4，交易密码弹框2/4走相同逻辑
export const getRunEnv = () => {
    const env = isTHSApp() ? 5 : _getRunEnv()
    if (env !== 3) return env
    return isTHSI18NApp() ? 4 : 3
}

// /**
//  * 获取运行环境
//  * @returns // 1.自研App 2.网厅 3.站外H5
//  */
// export const getRunEnv = () => {
//     if (JSBridge) {
//         // 自研App中一定共有JSBridge对象
//         return 1
//     } else if (getQueryString('wtToken', true) || localStorage.getItem('WTtoken') || isTHSApp()) {
//         // 网厅中query参数带WTtoken
//         return 2
//     } // 否则为站外H5
//     return 3
// }

/**
 * 获取当前接口版本
 * @returns // v0: 网厅接口版本， v1: 自研接口版本
 */
export const getPathVersion = () => {
    const runEnv = getRunEnv()
    // 网厅v0接口，自研与站外v1接口
    return runEnv === 2 ? 'v0' : 'v1'
}

/*
 * 获取页面来源
 */
export const getOrigin = () => {
    // 1：同花顺公版 2：同花顺OEM 3：Web网厅 4：移动网厅 5：利通天下 6：自研APP
    if (JSBridge) {
        // app
        return 6
    } else if (isTHSApp()) {
        //同花顺
        return 1
    }
    //网厅
    const isMobile = isDeviceMobile()
    return isMobile ? 4 : 3
}

/*
 * 获取皮肤颜色
 * white - 白皮肤 black - 黑皮肤
 * 同花顺通过 getCssStyle()获取皮肤属性值  (white - 白皮肤 black - 黑皮肤)
 */
export const getThemeType = () => {
    const DEFAULT_SKIN_TYPE = 'white'
    if (isTHSApp()) {
        const userAgent = navigator.userAgent
        const index = userAgent.indexOf('hxtheme')
        let theme = 'white'
        if (index > -1) {
            const match = userAgent.substr(index + 8, 1)
            0 == match ? (theme = 'white') : 1 == match && (theme = 'black')
        }
        return theme
    }
    const KEY = 'skinType'
    const reg = new RegExp(`(?:${KEY})/([^\\s]+)`)
    return (
        (window.navigator.userAgent.match(reg) || [])[1] ||
        getQueryString(KEY) ||
        getQueryString(KEY, true) ||
        localStorage.getItem(KEY) ||
        DEFAULT_SKIN_TYPE
    )
}
/*
 * 获取颜色类型
 * 1 - // 橙涨绿跌 2 -// 绿涨橙跌 3 - // 红涨绿跌 4 - // 绿涨红跌
 */
export const getPriceColorType = () => {
    const DEFAULT_PRICE_COLOR_TYPE = 1
    const KEY = 'priceColorType'
    const reg = new RegExp(`(?:${KEY})/([^\\s]+)`)
    return (
        (window.navigator.userAgent.match(reg) || [])[1] ||
        getQueryString(KEY) ||
        getQueryString(KEY, true) ||
        localStorage.getItem(KEY) ||
        DEFAULT_PRICE_COLOR_TYPE
    )
}
